"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.X_GEO_LOCATION_STATUS = exports.X_GEO_COUNTRY = void 0;
var X_GEO_LOCATION_STATUS = exports.X_GEO_LOCATION_STATUS = 'x-geo-location-status';
var X_GEO_COUNTRY = exports.X_GEO_COUNTRY = 'x-geo-country';